var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"bouton imageBouton boutonPlus",on:{"click":_vm.clicked}},[_vm._t("default"),_c('input',{ref:"import",attrs:{"id":"importBs","type":"file","multiple":_vm.multiple,"accept":_vm.accept},on:{"change":_vm.change}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }